// extracted by mini-css-extract-plugin
export var centerText = "_78-8";
export var container = "_78-0";
export var doughnutContainer = "_78-7";
export var legend = "_78-a";
export var legendItemColorDisplay = "_78-b";
export var legendItemLabel = "_78-d";
export var legendItemValue = "_78-c";
export var lg = "_78-5";
export var maxWidth = "_78-9";
export var md = "_78-4";
export var responsive = "_78-6";
export var sm = "_78-3";
export var xs = "_78-2";
export var xxs = "_78-1";